import { useEffect } from "react";
import localforage from "localforage";

const CACHE_TTL_MS = 100 * 60 * 1000; // 5 minutes
const CACHE_TIMESTAMP_KEY = "hg-cacheTimestamp";

const useSessionCheck = () => {
  useEffect(() => {
    const checkAndClearStorage = async () => {
      const sessionActive = sessionStorage.getItem("hg-sessionActive");
      const now = Date.now();

      if (!sessionActive) {
        await localforage.clear();
        sessionStorage.setItem("hg-sessionActive", "true");
        await localforage.setItem(CACHE_TIMESTAMP_KEY, now);
        return;
      }

      // Check TTL
      const lastTimestamp = await localforage.getItem<number>(CACHE_TIMESTAMP_KEY);
      if (!lastTimestamp || now - lastTimestamp > CACHE_TTL_MS) {
        await localforage.clear();
        await localforage.setItem(CACHE_TIMESTAMP_KEY, now);
      }
    };

    checkAndClearStorage();
  }, []);
};

export default useSessionCheck;
